import React, { useEffect, useRef, useState } from 'react'
import {
  CCol, CRow, CAlert, CForm, CFormInput, CFormLabel, CButton, CSpinner,
  CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter,
} from '@coreui/react'
import { api } from '../api/client'
import WwGrid, { WwColumn } from '../components/ww/WwGrid'
import { usePendiente } from '../components/ww/pendiente'

const columnas: WwColumn[] = [
  { key: 'paisCodigo', title: 'Codigo', type: 'number' },
  { key: 'paisNombre', title: 'Nombre' },
]

// Paises — réplica de paisgeneral.cs:53 (paisgeneral GX).
const PaisesPage: React.FC = () => {
  const [rows, setRows] = useState<any[]>([])
  const formRef = useRef<HTMLFormElement>(null)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState('')
  const { aviso, setAviso } = usePendiente()
  const [abierto, setAbierto] = useState(false)
  const [guardando, setGuardando] = useState(false)
  const [errorModal, setErrorModal] = useState('')
  const [form, setForm] = useState({ paisCodigo: '', paisNombre: '' })
  // Fila en edición (paisww.cs:2169 'DO UPDATE' → webobject pais Mode="UPD")
  const [editando, setEditando] = useState<any | null>(null)

  useEffect(() => {
    api.get<any[]>('/paises')
      .then(setRows)
      .catch((e: any) => setError(e.message))
      .finally(() => setCargando(false))
  }, [])

  const abrirNuevo = () => {
    setEditando(null)
    setForm({ paisCodigo: '', paisNombre: '' })
    setAbierto(true)
  }

  // Modificar (paisww.cs:2169-2175): carga la fila. PaisCodigo es llave y no cambia.
  const abrirEditar = (fila: any) => {
    setErrorModal('')
    setEditando(fila)
    setForm({ paisCodigo: String(fila.paisCodigo ?? ''), paisNombre: fila.paisNombre ?? '' })
    setAbierto(true)
  }

  const crear = async (e: React.FormEvent) => {
    e.preventDefault()
    setErrorModal('')
    setGuardando(true)
    try {
      const body = { paisCodigo: Number(form.paisCodigo), paisNombre: form.paisNombre }
      if (editando) {
        // UPD: la llave va en la URL (pais_bc.cs:344-364, BC000U7)
        await api.put(`/paises/${editando.paisCodigo}`, { paisNombre: form.paisNombre })
      } else {
        await api.post('/paises', body)
      }
      setAbierto(false)
      setEditando(null)
      api.get<any[]>('/paises').then(setRows)
    } catch (err: any) {
      setErrorModal(err.message)
    } finally {
      setGuardando(false)
    }
  }

  // Eliminar (paisww.cs:2177-2185 'DO DELETE'): el backend replica
  // OnDeleteControls0U29 (pais_bc.cs:452-456, BC000U9) → 409 si hay Cuentas.
  const eliminar = (fila: any) => {
    if (!window.confirm(`¿Eliminar el país ${fila.paisCodigo}?`)) return
    api.delete(`/paises/${fila.paisCodigo}`)
      .then(() => {
        setAviso('País eliminado.')
        api.get<any[]>('/paises').then(setRows)
      })
      .catch((e: any) => setError(e.message))
  }

  const [totalReg, setTotalReg] = useState(rows.length)
  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4>País</h4>
          <small className="text-body-secondary">{totalReg} {totalReg === 1 ? 'registro' : 'registros'}</small>
        </CCol>
      </CRow>
      {error && <CAlert color="danger">{error}</CAlert>}
      {aviso && <CAlert color="warning" dismissible onClose={() => setAviso('')}>{aviso}</CAlert>}

      <WwGrid
        title="País"
        columns={columnas}
        rows={rows}
        onTotalChange={setTotalReg}
        loading={cargando}
        onAgregar={abrirNuevo}
        onEditar={abrirEditar}
        onEliminar={eliminar}
      />

      <CModal visible={abierto} onClose={() => { setAbierto(false); setEditando(null) }}>
        <CModalHeader>
          <CModalTitle>{editando ? 'Modificar país' : 'Agregar país'}</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          {errorModal && <CAlert color="danger">{errorModal}</CAlert>}
          <CForm ref={formRef} onSubmit={crear}>
            <CRow className="g-3">
              <div className="w-100"><small className="text-body-secondary fw-semibold">País</small></div>
              <CCol md={4}><CFormLabel>Código</CFormLabel><CFormInput type="number" value={form.paisCodigo} disabled={editando !== null} onChange={(e) => setForm({ ...form, paisCodigo: e.target.value })} /></CCol>
              {/* Mayúsculas (patrón GX: nombres en BD en mayúsculas) */}
              <CCol md={8}><CFormLabel>Nombre</CFormLabel><CFormInput value={form.paisNombre} onChange={(e) => setForm({ ...form, paisNombre: e.target.value.toUpperCase() })} /></CCol>
            </CRow>
          </CForm>
        </CModalBody>
        <CModalFooter className="border-top">
          <CButton color="secondary" type="button" disabled={guardando} onClick={() => setAbierto(false)}>Cancelar</CButton>
          <CButton color="primary" type="button" disabled={guardando} onClick={() => formRef.current?.requestSubmit()}>{guardando ? <CSpinner size="sm" /> : 'Guardar'}</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PaisesPage
